export default "__VITE_ASSET__786a0a5e__"